import { injectable } from "inversify";
export function makeInjectable(target) {
    return injectable()(target);
}
export function bindSingletonImplementation(container, symbol, impl) {
    if (typeof impl === "function") {
        container.bind(symbol).to(impl).inSingletonScope();
    }
    else {
        container.bind(symbol).toConstantValue(impl);
    }
}
//# sourceMappingURL=util.js.map